<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GGEInt/tc-custom/9781534425774.jpg?1730524996165" alt="This image is the cover for the book Future King, The Revenge of Magic"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Future King, The Revenge of Magic
      </h1>
      <p class="bookDescription body article font2">
        <b>Fort’s continued adventures take more surprising twists and turns in this third novel in a thrilling series from the author of the <i>New York Times </i>bestselling <i>Story Thieves</i>!</b><br/><br/>Dealing with monster attacks and his missing father has been hard enough for Fort Fitzgerald in his first month at the Oppenheimer School. But there’s another school for magic, this one in the United Kingdom, that’s about to create even bigger problems.<br/><br/>Six of the Carmarthen Academy students found themselves lost in time when they first started learning magic. Now they’ve returned, with news of a coming war that the students claim only they can stop.<br/><br/>But their new plan for the world might lead to an even worse future, one that Fort and his friends are destined to help bring about, no matter how much they might want to fight it.<br/><br/>Can Fort change the future that the Time students have already seen play out? Or is he destined to pay for his past mistakes for all of time?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Riley
      </h2>
      
      <p class="authorDescription body article">James Riley lives in Virginia. He is the&#160;<I>New York Times&#160;</I>bestselling author of the Half Upon a Time, Story Thieves, Revenge of Magic, and Once Upon Another Time series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Aladdin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d652cbc